"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComponent = isComponent;
exports.isTheme = isTheme;
exports.isComponentOrTheme = isComponentOrTheme;
const Item_1 = require("../../Abstract/Item");
const domain_core_1 = require("@standardnotes/domain-core");
function isComponent(x) {
    if (!(0, Item_1.isDecryptedItem)(x)) {
        return false;
    }
    return x.content_type === domain_core_1.ContentType.TYPES.Component;
}
function isTheme(x) {
    if (!(0, Item_1.isDecryptedItem)(x)) {
        return false;
    }
    return x.content_type === domain_core_1.ContentType.TYPES.Theme;
}
function isComponentOrTheme(x) {
    if (!(0, Item_1.isDecryptedItem)(x)) {
        return false;
    }
    return x.content_type === domain_core_1.ContentType.TYPES.Component || x.content_type === domain_core_1.ContentType.TYPES.Theme;
}
